import React from 'react';
import Helmet from 'react-helmet';

export default ({
  themeColor,
  title,
  description,
  path
}) => Component => () => (
  <React.Fragment>
    <Helmet>
      <title>{title}</title>

      <meta name="description" content={description} />
      <meta name="image" content="https://wearewip.com/logo.png" />

      <meta itemProp="name" content={title} />
      <meta itemProp="description" content={description} />
      <meta itemProp="image" content="https://wearewip.com/logo.png" />

      <meta name="og:title" content={title} />
      <meta name="og:description" content={description} />
      <meta name="og:image" content="https://wearewip.com/logo.png" />
      <meta name="og:url" content={`https://wearewip.com${path}`} />
      <meta name="og:site_name" content="Work In Progress" />
      <meta name="og:locale" content="en_US" />
      <meta name="og:type" content="website" />

      <meta name="theme-color" content={themeColor} />
    </Helmet>
    <Component />
  </React.Fragment>
);
